import { createAPI } from '../../common'

export default {
  // 批量添加栏目
  postColumnBatch: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpmvno0cbudi', 'post', config),
  // 添加栏目
  postColumn: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpmvno', 'post', config),
  // 添加版次关系
  postColumnConfirm: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpmvno0dpogjsn', 'post', config),
  // 栏目排序
  putColumnSort: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpmvno0tpsu', 'put', config),
  // 删除栏目
  deleteColumn: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpmvno', 'delete', config),
  // 获取所有栏目
  getColumnAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpmvno0bmm', 'get', config),
  // 查询栏目
  getColumn: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpmvno', 'get', config),
  // 查询子栏目或者栏目组
  getColumnSubs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpmvno0tvct', 'get', config),
  // 查询版次、栏目关系
  getColumnRels: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpmvno0sfmt', 'get', config),
  // 获取报纸下所有栏目和栏目组
  getColumnPaper: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpmvno0qbqfs', 'get', config),
  // 获取版次、栏目关系列表
  getColumnRelslist: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpmvno0sfmtmjtu', 'get', config),
  // 查询根栏目
  getColumnRoots: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpmvno0spput', 'get', config),
  // 修改栏目
  putColumn: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpmvno', 'put', config),
  // 校验名称和code
  getColumnCheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztdpmvno0difdl', 'get', config)
}
